import { get, merge } from 'lodash';
import React, { PropTypes } from 'react';
import ValidatedForm from '../../../../../../common/components/ValidatedForm';
import TextField from '../../../../../../common/components/c_TextField';
import MaskedTextField from '../../../../../../common/components/c_MaskedTextField';
import DropDown from '../../../../../../common/components/c_DropDownMenu';
import DateInputDropDown from '../../../../../../common/components/DateInputDropDown';

export default class EducationRecord extends ValidatedForm {
  static propTypes = {
    education: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
    index: PropTypes.number
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      validation: Object.assign({}, props.validation)
    };
  }

  // Override ValidatedForm.formModel method
  get formModel() {
    return merge({}, get(this, 'props.education'), get(this, `props.tempState.education[${this.props.education.clientId}]`));
  }

  handleUpdate = (clientId, prop) => {
    return (model, field, event, value) => this.props.onChange(clientId, prop, event, value);
  }

  handleRemove = (clientId) =>
    () => this.props.onRemove(clientId)

  renderAttributes(prop, label, updateOn = 'onBlur', valueOn = 'defaultValue') {
    return {
      // need to replace '\n' with actual newline
      'data-id': prop,
      style: { margin: '0 7px 7px 7px;' },
      floatingLabelText: label,
      [valueOn]: (this.props.education[prop]),
      isDirty: !!get(this.state, `validation.${prop}.errors[0]`, false),
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      [updateOn]: this.validateUpdate(this.props.model, prop, this.handleUpdate(this.formModel.clientId, prop))
    };
  }

  renderMenuItems(items) {
    return {
      menuItems: typeof items === 'string' ? this.props.staticData[items] : items
    };
  }

  renderDegreeOther(props) {
    const clientId = get(props, 'education.clientId');
    const type = get(props, `tempState.education.${clientId}.degreeTypeId`, get(props, 'education.degreeTypeId'));
    const degrees = get(this.props, 'staticData.educationDegrees') || [];
    const other = degrees.find(d => d.subElement === 'Other');
    const none = degrees.find(d => d.name === 'None');

    if (other && type === other.id) {
      return (
        <div className='box'>
          <TextField
            {...this.renderAttributes('degreeTypeOther', 'Other Degree, Please specify') }
          />
        </div>
      );
    }
    else if (none && type === none.id) {
      return (
        <div className='box'>
          <MaskedTextField
            mask='999'
            hideMaskChar='true'
            {...this.renderAttributes('creditsEarned', 'Credits Earned')}
          />
        </div>
      );
    }

  }

  render() {
    const education = this.props.education;
    const index = this.props.index;

    return (
      <div
        key={index}
        data-id={`Container ${index}`}
        className='box-container-fixed'
      >
        <div className='box'>
          <DropDown
            {...this.renderAttributes('institutionTypeId', 'Institution Type', 'onChange', 'value')}
            {...this.renderMenuItems('educationInstitutionTypes')}
          />
        </div>
        <div className='box'>
          <TextField
            {...this.renderAttributes('institutionName', 'Institution Name')}
          />
        </div>
        <div className='box'>
          <DropDown
            {...this.renderAttributes('degreeTypeId', 'Degree Earned')}
            {...this.renderMenuItems('educationDegrees')}
          />
        </div>
        <div className='box'>
          <TextField
            {...this.renderAttributes('subjectOrMajor', 'Subjects or Major')}
          />
        </div>
        <div className='box'>
          <DateInputDropDown
            className='education-date-input'
            dateFormat={'MonthYear'}
            autoOk
            {...this.renderAttributes('dateAttendedStart', 'Attended From', 'onChange')}
          />
        </div>
        <div className='box'>
          <DateInputDropDown
            className='education-date-input'
            dateFormat={'MonthYear'}
            autoOk
            minDate={education.dateAttendedStart}
            {...this.renderAttributes('dateAttendedEnd', ' Attended To', 'onChange')}
          />
        </div>
        {
          this.renderDegreeOther(this.props)
        }
        <div
          data-id='remove-section'
          className='remove-section text-btn noTextSelect'
          onClick={this.handleRemove(education.clientId)}
        >
          Remove Section
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Background/c_Education/EducationRecord.js